import React from "react";
import { Badge } from "react-bootstrap";
import { Utensils, Clock, CheckSquare } from "lucide-react";
import { getScaledQuantity } from "./utils/recipeUtils";

const IngredientsSidebar = ({
    recipe,
    servings,
    onServingsChange,
    checkedIngredients,
    onToggleIngredient,
    isOpen,
    onClose,
    isDesktop
}) => {

    return (
        <>
            {/* Overlay Backdrop (Mobile only) */}
            {(!isDesktop && isOpen) && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 z-3 animate-fade-in"
                    onClick={onClose}
                    style={{ backdropFilter: 'blur(2px)' }}
                ></div>
            )}

            {/* Sidebar Content */}
            <div
                className={`bg-white shadow-lg transition-transform duration-300 d-flex flex-column border-end`}
                style={{
                    position: isDesktop ? 'sticky' : 'fixed',
                    top: 0,
                    left: 0,
                    height: '100vh',
                    zIndex: isDesktop ? 1 : 1040, // High z-index for fixed mobile sidebar, lower for sticky desktop
                    width: '350px',
                    maxWidth: '90vw',
                    transform: isOpen ? 'translateX(0)' : (isDesktop ? 'translateX(-350px)' : 'translateX(-100%)'),
                    marginLeft: (isDesktop && !isOpen) ? '-350px' : '0', // Push/Pull effect on desktop
                    flexShrink: 0
                }}
            >
                <div className="p-4 border-bottom d-flex align-items-center justify-content-between sticky-top bg-white z-1">
                    <div className="d-flex align-items-center gap-3">
                        <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold shadow-sm" style={{ width: '32px', height: '32px' }}>
                            <Utensils size={16} />
                        </div>
                        <h5 className="fw-bold font-serif m-0 text-dark">Einkaufsliste</h5>
                    </div>
                    <button className="btn btn-close" onClick={onClose}></button>
                </div>

                <div className="p-4 flex-grow-1 overflow-y-auto custom-scrollbar">
                    <div className="d-flex align-items-center gap-2 mb-4">
                        <Badge bg="secondary" className="bg-opacity-10 text-dark px-2 py-1 rounded-pill font-sans fw-semibold small border border-dark border-opacity-10">
                            {recipe.category || "Hauptgericht"}
                        </Badge>
                        <div className="d-flex align-items-center gap-2 small text-muted font-sans fw-medium">
                            <Clock size={14} />
                            <span>{parseInt(recipe.prepTime || 0) + parseInt(recipe.cookTime || 0)} Min.</span>
                        </div>
                    </div>

                    {/* Servings Control */}
                    <div className="d-flex align-items-center bg-white rounded-pill border px-1 shadow-sm w-fit-content mb-3 mx-auto">
                        <button className="btn btn-sm btn-link text-dark p-0 px-2 text-decoration-none fw-bold hover-scale" onClick={() => onServingsChange(-1)}>−</button>
                        <span className="font-sans fw-bold mx-2" style={{ minWidth: '20px', textAlign: 'center' }}>{servings}</span>
                        <button className="btn btn-sm btn-link text-dark p-0 px-2 text-decoration-none fw-bold hover-scale" onClick={() => onServingsChange(1)}>+</button>
                        <span className="small text-muted ms-1 me-2 border-start ps-2">Portionen</span>
                    </div>

                    <div className="d-flex flex-column gap-2">
                        {recipe.ingredients.map((ing, idx) => (
                            <div
                                key={ing.id || idx}
                                className={`d-flex align-items-center gap-2 py-2 px-2 rounded-3 transition-all ${checkedIngredients.has(ing.id || idx) ? 'opacity-50 bg-light' : 'bg-white hover-bg-gray-50 border border-light'}`}
                                onClick={() => onToggleIngredient(ing.id || idx)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div
                                    className={`rounded-circle border d-flex align-items-center justify-content-center transition-all flex-shrink-0 ${checkedIngredients.has(ing.id || idx) ? 'bg-primary border-primary text-white' : 'bg-white border-secondary border-opacity-25'}`}
                                    style={{ width: '20px', height: '20px' }}
                                >
                                    {checkedIngredients.has(ing.id || idx) && <CheckSquare size={12} strokeWidth={3} />}
                                </div>
                                <div className="font-sans d-flex align-items-baseline gap-2 text-dark" style={{ lineHeight: '1.2' }}>
                                    <span className="fw-bold text-nowrap bg-light px-1 rounded small">{getScaledQuantity(ing.quantity, recipe.servings, servings)} {ing.unit}</span>
                                    <span className={`${checkedIngredients.has(ing.id || idx) ? 'text-decoration-line-through' : ''}`}>{ing.name}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default IngredientsSidebar;
